<template>
  <t-modal @close="$emit('close')">
    <div class="modal-header">Добавить права</div>
    <div class="modal-body">
      <form id="add-permission-form" @submit.prevent="onSubmit" class="form">
        <t-select-multiple
          v-model="selectedUsers"
          label="Пользователи"
          placeholder="Начните вводить ФИО или e-mail..."
          :options="searchUsers"
        />
        <t-select v-model="selectedRole" label="Выберите роль" :options="filteredRoles"/>
      </form>
    </div>
    <div class="modal-footer join">
      <button
        class="btn btn--primary btn--full-width"
        form="add-permission-form"
        type="submit"
        :disabled="!canSubmit || isLoading"
      >
        {{ isLoading ? 'Сохранение...' : 'Добавить' }}
      </button>
    </div>
  </t-modal>
</template>

<script setup>
import { TModal, TSelectMultiple, TSelect } from '@shared/ui'
import { ref, computed } from 'vue'
import { usePermissions } from '../model/usePermissions'

const props = defineProps({
  roles: Array,
  preselectedRole: { type: String, default: null },
})
const emit = defineEmits(['close'])

const { searchUsers, createPermission, fetchPermissionsList } = usePermissions()

const selectedRole = ref(props.preselectedRole)
const selectedUsers = ref([])
const isLoading = ref(false)

const filteredRoles = computed(() => props.roles.filter(role => role.value))
const canSubmit = computed(() => selectedUsers.value.length > 0 && selectedRole.value)

const onSubmit = async () => {
  if (!canSubmit.value) return
  isLoading.value = true
  try {
    await Promise.allSettled(
      selectedUsers.value.map(user =>
        createPermission({
          user_id: user.value,
          role: selectedRole.value,
          name: user.text
        })
      )
    )
    await fetchPermissionsList()
    emit('close')
  } finally {
    isLoading.value = false
  }
}
</script>
